export default __webpack_public_path__ + "static/media/image-board-study-now-n-w@3x.5c3c08b0.webp";